import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Shell } from "@/components/Shell";
import { createSubmission } from "@/lib/storage";
import { SECTIONS } from "@/data/questionnaire";

export default function StartPage() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const total = SECTIONS.reduce((n, s) => n + s.questions.length, 0);

  const start = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    const sub = createSubmission(name.trim());
    navigate(`/compila/${sub.id}`);
  };

  return (
    <Shell>
      <form onSubmit={start} className="card p-7 sm:p-10 fade-up">
        <p className="eyebrow">Prima di passare il tablet</p>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#2C221E] mt-2">Chi risponderà?</h1>
        <p className="text-[#5C4D46] mt-3">Scrivi il nome dei titolari, poi passa il tablet. {total} domande in {SECTIONS.length} brevi sezioni, circa dieci minuti.</p>
        <label className="block mt-8">
          <span className="eyebrow">Nome</span>
          <input autoFocus className="field mt-2 text-lg" placeholder="es. Maria e Giovanni" value={name} onChange={(e) => setName(e.target.value)} data-testid="input-respondent-name" />
        </label>
        <div className="flex flex-wrap gap-3 mt-8 justify-between">
          <button type="button" className="btn btn-ghost" onClick={() => navigate("/")} data-testid="back-home-btn">
            <ArrowLeft size={18} /> Indietro
          </button>
          <button type="submit" className="btn btn-primary" disabled={!name.trim()} data-testid="start-survey-btn">
            Inizia e passa il tablet <ArrowRight size={18} />
          </button>
        </div>
      </form>
    </Shell>
  );
}
